import { createRootRouteWithContext, Outlet, useMatches } from "@tanstack/react-router"
import { useEffect } from "react"

import type { useAuth } from "#lib/auth.tsx"
import { NotFoundPage } from "#pages/404/_404.tsx"

declare module "@tanstack/react-router" {
  interface StaticDataRouteOption {
    title?: string
  }
}

type RouterContext = {
  auth: ReturnType<typeof useAuth>
}

const RootComponent = () => {
  const matches = useMatches()

  useEffect(() => {
    const match = [...matches].reverse().find((m) => m.staticData?.title)

    const title = match?.staticData?.title

    document.title = title ? `${title} - Atlant Admin` : "Atlant Admin"
  }, [matches])

  return <Outlet />
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
  notFoundComponent: NotFoundPage,
})
